import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
    size = 'md', 
    color = 'primary', 
    fullScreen = false,
    text = null,
    overlay = false 
}) => {
    const sizeClasses = {
        sm: 'loading-spinner-sm',
        md: 'loading-spinner-md',
        lg: 'loading-spinner-lg',
        xl: 'loading-spinner-xl'
    };

    const colorClasses = {
        primary: 'loading-spinner-primary',
        white: 'loading-spinner-white',
        dark: 'loading-spinner-dark',
        success: 'loading-spinner-success',
        warning: 'loading-spinner-warning',
        danger: 'loading-spinner-danger'
    };

    if (fullScreen) {
        return (
            <div className={`loading-fullscreen ${overlay ? 'loading-overlay' : ''}`}>
                <div className="loading-content">
                    <div className={`loading-spinner ${sizeClasses[size]} ${colorClasses[color]}`}>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                    </div>
                    {text && <p className="loading-text">{text}</p>}
                </div>
            </div>
        );
    }

    return (
        <div className="loading-inline">
            <div className={`loading-spinner ${sizeClasses[size]} ${colorClasses[color]}`}>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
            </div>
            {text && <span className="loading-text-inline">{text}</span>}
        </div>
    );
};

export default LoadingSpinner;

